var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.724,
    height: 180.404,
    viewBox: "0 0 180.724 180.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(229.875 15.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-229.875 -15.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-191.164,165.176C-213.089,134.32-240.519,87.471-225.642,37.1-219.9,17.638-204.805,2.463-182-6.79a114.77,114.77,0,0,1,86.414.011C-72.917,2.614-57.3,18.674-52.744,37.285c12.6,51.487-10.118,90.969-34.471,126.995l-6.833-4.617c23.318-34.5,45.095-72.207,33.294-120.416C-64.68,23.215-78.527,9.217-98.744.841A106.463,106.463,0,0,0-178.9.852c-14.22,5.772-32.5,17.15-38.83,38.583-13.861,46.926,12.36,91.51,33.29,120.964Z",
    transform: "translate(229.875 15.227)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-204.248 103.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-173.65,88.719a29.165,29.165,0,0,1-28.926,0,28.591,28.591,0,0,1-14.463-24.8,28.592,28.592,0,0,1,14.463-24.805",
    transform: "translate(220.252 -35.897)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-186.33,97.538a32.387,32.387,0,0,1-16.058-4.244,31.9,31.9,0,0,1-16.081-27.6,31.889,31.889,0,0,1,16.081-27.591A3.209,3.209,0,0,1-198,39.3a3.212,3.212,0,0,1-1.2,4.384A25.45,25.45,0,0,0-212.043,65.7,25.448,25.448,0,0,0-199.2,87.715a26.032,26.032,0,0,0,25.74,0,3.218,3.218,0,0,1,4.384,1.193,3.218,3.218,0,0,1-1.2,4.386A32.374,32.374,0,0,1-186.33,97.538Z",
    transform: "translate(218.469 -37.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(-123.822 103.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-181.245,88.721a29.18,29.18,0,0,0,28.928,0,28.591,28.591,0,0,0,14.463-24.805A28.6,28.6,0,0,0-152.317,39.11",
    transform: "translate(184.457 -35.897)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-165,97.541a32.375,32.375,0,0,1-16.056-4.247,3.216,3.216,0,0,1-1.2-4.386,3.219,3.219,0,0,1,4.384-1.193,26.028,26.028,0,0,0,25.738,0A25.453,25.453,0,0,0-139.284,65.7,25.447,25.447,0,0,0-152.13,43.683a3.214,3.214,0,0,1-1.193-4.384,3.209,3.209,0,0,1,4.381-1.2A31.893,31.893,0,0,1-132.858,65.7a31.9,31.9,0,0,1-16.083,27.6A32.377,32.377,0,0,1-165,97.541Z",
    transform: "translate(182.674 -37.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-189.597 103.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-180.354,92.7a3.3,3.3,0,0,1-2.851-1.631L-211.5,42.76a3.3,3.3,0,0,1,1.18-4.514,3.3,3.3,0,0,1,4.514,1.18l28.29,48.308a3.3,3.3,0,0,1-1.177,4.512A3.284,3.284,0,0,1-180.354,92.7Z",
    transform: "translate(211.948 -37.794)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-123.809 103.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-181.2,88.6l28.74-49.433",
    transform: "translate(184.499 -35.862)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-179.374,93.727a3.3,3.3,0,0,1-1.654-.447,3.3,3.3,0,0,1-1.193-4.512l28.74-49.433a3.3,3.3,0,0,1,4.509-1.193,3.3,3.3,0,0,1,1.193,4.509l-28.74,49.433A3.3,3.3,0,0,1-179.374,93.727Z",
    transform: "translate(182.668 -37.693)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-180.991 97.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-199.145,37.711l24.612,42.854a2.964,2.964,0,0,1-1.076,4.035l-2.024,1.175a2.931,2.931,0,0,1-4.013-1.083l-24.61-42.852a2.963,2.963,0,0,1,1.074-4.035l2.024-1.175A2.932,2.932,0,0,1-199.145,37.711Z",
    transform: "translate(209.948 -32.934)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-177.262,91.3a6.325,6.325,0,0,1-1.618-.213,6.2,6.2,0,0,1-3.795-2.921l-24.612-42.857a6.262,6.262,0,0,1,2.281-8.527l2.022-1.175a6.188,6.188,0,0,1,4.734-.631,6.2,6.2,0,0,1,3.795,2.923l24.612,42.85a6.273,6.273,0,0,1-2.281,8.531l-2.027,1.177A6.177,6.177,0,0,1-177.262,91.3ZM-201.4,42.32l24.259,42.248,1.407-.818L-199.993,41.5Zm25.832,41.717h0Z",
    transform: "translate(208.118 -34.766)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-136.322 97.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-161.766,37.9l-24.61,42.854a2.961,2.961,0,0,0,1.074,4.033l2.024,1.175a2.929,2.929,0,0,0,4.013-1.081l24.61-42.854a2.961,2.961,0,0,0-1.074-4.033l-2.024-1.175A2.928,2.928,0,0,0-161.766,37.9Z",
    transform: "translate(190.067 -33.121)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-179.99,91.489a6.192,6.192,0,0,1-3.116-.845l-2.022-1.171a6.277,6.277,0,0,1-2.281-8.531L-162.8,38.088A6.2,6.2,0,0,1-159,35.167a6.183,6.183,0,0,1,4.736.631l2.022,1.173a6.272,6.272,0,0,1,2.283,8.529l-24.612,42.857a6.209,6.209,0,0,1-3.8,2.921A6.321,6.321,0,0,1-179.99,91.489Zm-1.532-7.552,1.409.816,24.262-42.248-1.4-.816Zm21.586-44.207h0Z",
    transform: "translate(188.238 -34.953)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.b2d0790b85ec9345b509769a09e4f12d.svg";
export { ForwardRef as ReactComponent };